/**
 * Internal dependencies.
 */
import edit from './edit';
import save from './save';
import metadata from './block.json';
import { ButtonsIcon as icon } from '../../components/Icons';

/**
 * WordPress dependencies.
 */
import { __ } from '@wordpress/i18n';
import { Icon } from '@wordpress/components';

/**
 * Block constants
 */
const { name, category, attributes } = metadata;

const settings = {
	title: __( 'Buttons' ),
	description: __( 'Gutenify button.' ),
	icon: <Icon icon={ icon } />,
	keywords: [
		'gutenify',
		__( 'Button' ),
		__( 'Buttons' ),
	],
	example: {
		attributes: {
			image: {
				url: '',
				id: '',
			},
		},
	},
	attributes,
	edit,
	save,
	supports: {
		html: false,
		anchor: true,
		align: [ 'wide', 'full' ],
	},
};

export { name, category, settings };
